import { render } from "./MultipleInput.vue?vue&type=template&id=6ff18733"
import script from "./MultipleInput.vue?vue&type=script&lang=js"
export * from "./MultipleInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__